import React from 'react';

const GuidedSetupContext = React.createContext();

export const { Provider } = GuidedSetupContext;
export const useGuidedSetupContext = () => React.useContext(GuidedSetupContext);
